export default __webpack_public_path__ + "static/media/ipbloc.2d5abee5.png";